
export enum GameEventType {
	RoomEdit,
	KeyPressed,
	RotateIntersection,
	ActivateSink,
	ActivateFeature,
	FlushPipe,
	HoverButton,
	DeliveryRequest
}
